export default {  

    end: "Farmer 4.0 Profiliniz",

    profile: "Profil",

    restart: "Testi Yeniden Başlat",

    submit: "Gönder",

    print: "Profilinizi PDF olarak indirin",

    data: "Verileriniz",

    progress: "İlerleme",

    confirm: {

        restart: 'TÜM VERİLERİNİZİ KAYBETMEK ve testi yeniden başlatmak istediğinizden emin misiniz?'

    },

    steps: {

        "0-1": "EĞİTİM SEVİYESİNİN DEĞERLENDİRİLMESİ",

        "0-2": "TARIMDA GİRİŞİMCİLİK DENEYİMİ",

        "1-1": "TARIMDA GEÇMİŞ DENEYİMLERİN TANIMLANMASI",

        "1-2": "TARIMDA GEÇMİŞ DENEYİMLERİN TANIMLANMASI",

        "1-3": "TARIMDA GEÇMİŞ DENEYİMLERİN TANIMLANMASI",

        "1-4": "TARIMDA GEÇMİŞ DENEYİMLERİN TANIMLANMASI",

        "2": "GİRİŞİMCİLİK EĞİLİMİ",

        "3-1": "BAŞARILI BİR GİRİŞİMCİ OLMAK İÇİN YUMUŞAK BECERİLER - YARATICILIK",

        "3-2": "BAŞARILI GİRİŞİMCİ OLMAK İÇİN YUMUŞAK BECERİLER - İLETİŞİM BÖLÜM 1",

        "3-3": "BAŞARILI GİRİŞİMCİ OLMAK İÇİN YUMUŞAK BECERİLER - İLETİŞİM BÖLÜM 2",

        "3-4": "BAŞARILI GİRİŞİMCİ OLMAK İÇİN YUMUŞAK BECERİLER - İLETİŞİM BÖLÜM 3",

        "3-5": "BAŞARILI GİRİŞİMCİ OLMAK İÇİN YUMUŞAK BECERİLER - İLETİŞİM BÖLÜM 4",

        "4-1": "BİT YETERLİLİKLERİ - ANAHTAR YETERLİLİKLER",

        "4-2-1": "ICT FARMER 4.0 YETKINLIKLERI",

        "4-2-2": "ICT FARMER 4.0 YETKINLIKLERI",

        "4-2-3": "ICT FARMER 4.0 YETKINLIKLERI",

        "4-2-4": "ICT FARMER 4.0 YETKINLIKLERI",

        "4-2-5": "ICT FARMER 4.0 YETKINLIKLERI",

        "4-2-6": "ICT FARMER 4.0 YETKINLIKLERI",

        "5-1": "ÇİFTÇİ 4.0 OLMAK İÇİN DİĞER MESLEKİ YETERLİLİKLER",

        "5-2": "ÇİFTÇİ 4.0 OLMAK İÇİN DİĞER MESLEKİ YETERLİLİKLER",

        "5-3": "ÇİFTÇİ 4.0 OLMAK İÇİN DİĞER MESLEKİ YETERLİLİKLER",

    },

    questions: {

        "0-1-1" : "Eğitim seviyenizi seçin", 

        "0-2-1" : "Tarım alanında girişimci olmak istediğiniz / olmak istediğiniz alan nedir?",

        "1-1-1" : "Bir girişimci olarak tarımda daha önce deneyiminiz var mı?",

        "1-2-1" : "Girişimci olmak istediğiniz tarım alanında başka deneyimleriniz var mı?",

        "1-3-1" : "Tarımda daha önce ne gibi deneyimleriniz var?",

        "1-4-1" : "Bu pozisyonda ne kadar zaman geçirdiniz?",

        "1-4-2" : "Bu deneyimi edindiğinizden bu yana ne kadar zaman geçti?",

        "2-1" : "Düzenli olarak haftada 50 saat veya daha fazla çalışmaya hazırım.",

        "2-2" : "Ailem işe girmeme destek olacak. Ailem bir iş kurma dileğimi destekleyecek",

        "2-3" : "Gerektiğinde hem finansal hem de işle ilgili riskleri kabul etmeye hazırım.",

        "2-4" : "Düzenli istihdamın sağladığı tüm yan haklara ihtiyacım yok (örn. Emeklilik katkıları, ücretli tatiller).",

        "2-5" : "İşimin başarıları ve / veya başarısızlıkları için tüm sorumluluğu üstlenmeye hazırım.",

        "2-6" : "Kendi işime sahip olarak daha fazla finansal başarı elde edeceğim. Kendi işim varsa, finansal başarı olasılığı daha yüksektir.",

        "2-7" : "Bir projeyi başarıyla tamamladığımda büyük bir gurur duyuyorum.",

        "2-8" : "Uzun süre korunabilen yüksek enerji seviyem var.",

        "2-9" : "Kendi iş ödevlerim ve işimi etkileyen kararlarım üzerinde kontrol sahibi olmaktan zevk alıyorum.",

        "2-10" : "Kendi başarılarımdan ve başarısızlıklarımdan sorumlu olduğuma inanıyorum.",

        "2-11" : "Çok fazla çaba gerektirse bile olumlu sonuçlar almak için güçlü bir arzum var. ",

        "2-12" : "Bir işletmeyi nasıl yöneteceğimi iyi anlıyorum.",

        "2-13" : "İşlerin hızla değiştiği durumlarda hareket edebilirim.",

        "2-14" : "Ebeveynlerimden biri veya her ikisi de girişimciydi.",

        "2-15" : "Birlikte çalıştığım diğerlerinden daha iyi yeteneklerime ve becerilere sahip olduğuma inanıyorum.",

        "2-16" : "İnsanlar bana güveniyor ve beni dürüst ve güvenilir olarak görüyor.",

        "2-17" : "Karşılaşabileceğim engeller ve zorluklar ne olursa olsun, başladığım her projeyi her zaman tamamlamaya çalışıyorum.",

        "2-18" : "Başkaları güldüğünde veya yaptığım için beni eleştirdiğinde bile bir şey yapmaya hazırım.",

        "2-19" : "Hızlı karar verebilirim.",

        "2-20" : "İyi bir arkadaş, profesyonel ve iş tanıdık ağım var.",

        "3-1-1" : "İş yerinde bir sorunla karşılaştığımda, birkaç olası alternatif çözüm bulmayı seviyorum.",

        "3-1-2": "Yeni bir görev alırsam, herhangi bir sorun yaşamamak için talimatları dikkatlice izlemeyi tercih ederim.",

        "3-1-3": "Tuhaf ve alışılmadık bir şey gördüğümde, rahatsızlıktan kaçınmak için karışmamayı tercih ederim.", 

        "3-1-4": "Bir tartışmada, aynı fikirlere sahip olmasam / paylaşmasam bile başkalarının fikirlerini dinlemeyi severim.",

        "3-1-5": "İşler net olmadığında, daha iyi anlamak için açıklamalar isterim.",

        "3-1-6": "Tekrarlayan iş yapmam gerektiğinde, genellikle görevi bitirmek için (ya daha hızlı bir yöntem, yeni bir yöntem bulmak ya da işe yaramaz olmadığından emin olmak için) daha hızlı yapmak, yeni bir şekilde yapmak için farklı yollar ararım. bir şekilde, ya da yararsız olduğu için yapmamam gerekip gerekmediğini anlayın)",

        "3-1-7": "Duygusal ve dürtüsel argümanları dışarıda bırakarak \"mantık ve rasyonellik\" ile akıl yürütmeyi tercih ederim.",

        "3-1-8": "Yeni zorlukları seviyorum - beni elimden gelenin en iyisini yapmaya motive ediyorlar.",

        "3-1-9": "Fikirlerle oynamayı severim.",

        "3-1-10": "Şu ifadeye katılıyorum: \"Kopyalama yararlıdır çünkü yeniliğe izin verir\".",

        "3-1-11": "Karmaşık durumlarda uzmanlara veya uzman olarak gördüklerime giderim.",

        "3-1-12": "Başkalarını fikrimin doğru olduğuna ikna etmek için fikrim için savaşmaya, açıklamaya ve değerini kanıtlamaya hazırım.",

        "3-1-13": "Küçük dozlarda anarşi, inovasyon için güçlü bir araçtır.",

        "3-1-14": "Görevlere tam olarak tamamlamadan başlıyorum.",

        "3-1-15": "Ofis işlerinde yaratıcı olmak imkansız.",

        "3-1-16": "İşleri değiştirirsem, rutin görevleri olan veya hangi görevleri yapmam gerektiğini bildiğim birini tercih ederim.",

        "3-1-17": "İş yerinde karmaşık durumlar olduğunda, bunun hakkında çok fazla düşünmemeye çalışıyorum. Bir çözüm bulmak için sezgimi kullanıyorum.",

        "3-1-18": "Bir görevin yönetim ve muhasebe yönlerinin önemli olduğuna ve bu dikkati stratejik önceliklere odaklayacağına inanmıyorum.",

        "3-1-19": "Bir görevin yaratıcı aşamasını tercih ederim çünkü yeni fikirler üretmek için başkalarıyla işbirliği yapabilirim.",

        "3-1-20": "Sanatı / beşeri bilimleri doğa / finans bilimlerine tercih ederim.",

        "3-1-21": "İstenilen sonuca ulaşmanın alternatif yollarının olabileceği gerçeğine açığım.",

        "3-1-22": "İş yerinde yenilikçi olmak bir sınırlamadır. Grubun geri kalanıyla aynı fikirde olmak daha iyidir.",

        "3-1-23": "Bir restoran ya da bar seçtiğimde zaten bildiklerimi tercih ederim çünkü ne alacağımı biliyorum.",

        "3-1-24": "Ciddi ve kritik durumlar söz konusu olduğunda bile olası bir çözüm olduğunu düşünmeyi seviyorum. Sadece bakman gerek. Umudunu kaybetmeye yardımcı olmaz.",

        "3-1-25": "İş yerinde yaratıcılığı geliştirecek yöntem ve teknikleri bilir ve uygularım.",

        "3-2-1": "Benimle konuşan kişiyi etkileyebilirim.",

        "3-2-2": "En çok konuşan kişi tartışmada daha güçlüdür.",

        "3-2-3": "Fikirlerimi nasıl aktaracağımı biliyor muyum?",

        "3-2-4": "Tartışmalarda rahat hissediyorum.",

        "3-2-5": "Bir tartışmada her zaman bir kazanan ve bir kaybeden vardır.",

        "3-2-6": "Tartışmadaki diğer kişiyi utandırmaktan korkmuyorum.",

        "3-2-7": "Kimseden korkmuyorum.",

        "3-2-8": "Çelişkilerden hoşlanırım.",

        "3-2-9": "Sinirlenebilmek gerekli.",

        "3-2-10": "Bir tartışmada kazanmak istiyorum.",

        "3-3-1": "Fikirlerimi genellikle güçlü bir inançla savunurum",

        "3-3-2": "Nadiren kafam karışır",

        "3-3-3": "Katılmadığım bir fikri savunabilirim",

        "3-3-4": "Diğer kişinin neyi başarmaya çalıştığını / başka birinin niyetini anlamaya çalışıyorum.",

        "3-3-5": "Bir fikrin açıklamasını sormakta kendimi rahat hissediyorum veya bir fikri anlamadığımı söyleyerek rahat hissediyorum",

        "3-3-6": "Başkalarının dikkatini çekebiliyorum ve onları meşgul edebiliyorum",

        "3-3-7": "Biliyorum hem ben hem de konuştuğum kişi hata yapabilir",

        "3-3-8": "Fikirlerimi şiddetle savunuyorum",

        "3-3-9": "Çatışma aramıyorum ama onlardan korkmuyorum",

        "3-3-10": "Fikrimi manipüle edilmeden değiştirebilirim",

        "3-4-1": "Sık sık hayal kurarım",

        "3-4-2": "İstesem bile sık sık konuşmaya cesaret edemiyorum",

        "3-4-3": "Fikirlerim hakkında belirli insanlara konuşmamayı tercih ederim",

        "3-4-4": "Bazen konuşurken ne söyleyeceğimi unutuyorum",

        "3-4-5": "Çatışmaya dahil olmayı ve bundan kaçınmaya çalışmayı sevmiyorum",

        "3-4-6": "Fikirlerimi nasıl savunacağımı bilmediğim için genellikle tartışmanın dışında kalıyorum",

        "3-4-7": "Kavgaya katılmak yerine tartışmanın bir parçası olmadığımı daha iyi hissediyorum",

        "3-4-8": "Keşke ne zaman daha iddialı olabilseydim (ihtiyaçlarımı daha güçlü bir şekilde ifade etsem)",

        "3-4-9": "Bana sorulduğunda bile kendimi net bir şekilde ifade etmek zor",

        "3-4-10": "Nadiren ilk konuşurum",

        "3-5-1": "Çatışmalardan kaçınırım çünkü hiçbir şeye yol açmazlar",

        "3-5-2": "Çelişkili ve / veya beklenmedik argümanlar kullanmayı seviyorum",

        "3-5-3": "Konuşan kişinin cesaretini kırabilmek gerekli",

        "3-5-4": "Başkalarının onlar hakkında bilgi edinmek için konuşmasına izin veriyorum",

        "3-5-5": "Katılmadığım bir bakış açısını savunmakta iyiyim",

        "3-5-6": "İltifat edildiğinde insanlar daha kolay ikna edilebilir",

        "3-5-7": "Önce konuşmak gereksiz bir risktir",

        "3-5-8": "Tartışmadaki diğer insanlar arasında bir tartışmaya neden olmak, bir durumun kontrolünü ele geçirmenin iyi bir yoludur",

        "3-5-9": "Başkalarının onlara katılmadığını düşündüğümde fikirlerimi nasıl gizleyeceğimi biliyorum",

        "3-5-10": "To cause an argument between the other people in the discussion is a good way to gain control of a situation when I think others don't agree with them",

        "4-1-1": "Bir kelime işlemci programı kullanma, ör. Word, Pages, Writer, Google Dokümanlar vb.",

        "4-1-2": "Bir elektronik tablo programı kullanma, örn. Excel, Numbers, Calc, Google Sheets vb.",

        "4-1-3": "Bilgi bulmak için interneti kullanma",

        "4-1-4": "İletişim araçlarını ve sosyal medyayı kullanma, ör. e-posta, Facebook, LinkedIN,",

        "4-2-1": "CAD'de çalışabiliyor musunuz?",

        "4-2-2": "CAE'de çalışabiliyor musunuz?",

        "4-2-3": "CAM'de çalışabiliyor musunuz??",

        "4-2-4": "RE'de çalışabiliyor musunuz??",

        "4-2-5": "Katmanlı imalat alanında çalışabiliyor musunuz?",

        "4-2-6": "Kendinizi ve çiftliğinizi / faaliyetlerinizi tanıtmak veya ürünlerinizi satmak için sosyal medyayı (ör. Facebook, Instagram, Pinterest…) veya bir web sitesini kullanabiliyor musunuz?",

        "5-1": "GDPR kurallarına göre bir \"dijital çiftçiler\" ağını nasıl oluşturacağınızı ve 4.0 teknolojilerini tanıtan FABLAB konseptine dayalı olarak çiftliğiniz için uygun bir yönetişim modelini nasıl benimseyeceğinizi biliyor musunuz?",

        "5-2": "İşletmenizin uluslararasılaşması konusunda uzman mısınız?",

        "5-3": "\"Sürdürülebilir tarımı\" biliyor musunuz ve uyguluyor musunuz?",

    },

    answers: {

        "yes": "Evet",

        "no": "Hayir",

        "s_agree" : "Kesinlikle katılıyorum",

        "agree": "Katılıyorum",

        "sw_agree": "Biraz katılıyorum",

        "disagree" : "Katılmıyorum",

        "s_disagree": "Kesinlikle katılmıyorum",

        "never": "Asla",

        "rarely": "Seyrek",

        "often": "Sıklıkla",

        "always": "Her zaman",

        "true": "Doğru",

        "false": "Yanlış",

        "insecure": "Güvensizim ve bu tür bir aracı kullanmak için yardıma ihtiyacım var",

        "confident": "Kendime oldukça güveniyorum ve genellikle bu aracı kullanırken çözümleri kendim buluyorum",

        "indipendent": "Bağımsız ve kendime güvenerek çalışıyorum ve başkalarına bu aracı nasıl kullanacaklarını öğretebiliyorum",

        "dontknow": "Bilmiyorum",   

        "0-1-1-0": "Eğitim yok",

        "0-1-1-1": "Orta okul diploması",

        "0-1-1-2": "Zorunlu eğitim sertifikası",

        "0-1-1-3": "Mesleki Sertifika",

        "0-1-1-4": "Lise Diploması",

        "0-1-1-5": "IFTS veya ITS sertifikası",

        "0-1-1-6": "Lisans derecesi veya ilk aşama yüksek eğitim",

        "0-1-1-7": "Yüksek lisans veya ikinci aşama yüksek eğitim",

        "0-1-1-8": "Araştırma Doktorası - Doktora",

        "0-2-1-11": "Tahılların (pirinç hariç), baklagillerin ve yağlı tohumların yetiştirilmesi", 

        "0-2-1-12": "Çeltik (kabuklu pirinç) yetiştirilmesi", 

        "0-2-1-13": "Sebze, kavun-karpuz, kök ve yumru sebzelerin yetiştirilmesi",

        "0-2-1-14": "Şeker kamışı yetiştirilmesi", 

        "0-2-1-15": "Tütün yetiştirilmesi", 

        "0-2-1-16": "Lifli bitkilerin yetiştirilmesi", 

        "0-2-1-17": "Tek yıllık (uzun ömürlü olmayan) diğer bitkisel ürünlerin yetiştirilmesi", 

        "0-2-1-21": "Üzüm yetiştirilmesi", 

        "0-2-1-22": "Tropikal ve subtropikal meyvelerin yetiştirilmesi", 

        "0-2-1-23": "Turunçgillerin yetiştirilmesi", 

        "0-2-1-24": "Yumuşak çekirdekli meyvelerin ve sert çekirdekli meyvelerin yetiştirilmesi", 

        "0-2-1-25": "Diğer ağaç ve çalı meyvelerinin ve sert kabuklu meyvelerin yetiştirilmesi", 

        "0-2-1-26": "Yağlı meyvelerin yetiştirilmesi", 

        "0-2-1-27": "İçecek üretiminde kullanılan bitkisel ürünlerin yetiştirilmesi", 

        "0-2-1-28": "Baharatlık, aromatik (ıtırlı), uyuşturucu nitelikte ve eczacılıkla ilgili bitkisel ürünlerin yetiştirilmesi", 

        "0-2-1-29": "Diğer çok yıllık (uzun ömürlü) bitkisel ürünlerin yetiştirilmesi",  

        "0-2-1-30": "Dikim için bitki yetiştirilmesi", 

        "0-2-1-41": "Sütü sağılan büyük baş hayvan yetiştiriciliği", 

        "0-2-1-42": "Diğer sığır ve manda yetiştiriciliği", 

        "0-2-1-43": "At ve at benzeri diğer hayvan yetiştiriciliği", 

        "0-2-1-44": "Deve ve devegillerin yetiştiriciliği", 

        "0-2-1-45": "Koyun ve keçi yetiştiriciliği", 

        "0-2-1-46": "Domuz yetiştiriciliği", 

        "0-2-1-47": "Kümes hayvanları yetiştiriciliği", 

        "0-2-1-48": "Diğer hayvan yetiştiriciliği", 

        "0-2-1-50": "Karma çiftçilik", 

        "0-2-1-61": "Bitkisel üretimi destekleyici faaliyetler", 

        "0-2-1-62": "Hayvan üretimini destekleyici faaliyetler", 

        "0-2-1-63": "Hasat sonrası bitkisel ürünler ile ilgili faaliyetler ", 

        "0-2-1-64": "Bitkisel üretim için tohumun işlenmesi", 

        "0-2-1-70": "Avcılık, tuzakla avlanma ve ilgili hizmet faaliyetleri", 

        "1-3-1-1" : "Eğitim geçmişi",

        "1-3-1-2" : "Gönüllü çalışma",

        "1-3-1-3" : "Diğer deneyimler",

        "1-4-1-1" : "3 yıldan az",

        "1-4-1-2" : "3 yıldan fazla",

    },

    results: {

        "1-1": "Bir girişimci olarak tarım alanında daha önceden deneyimleriniz olsa bile, FARMER 4.0 platformumuz, 4.0 çiftçileri olarak başarınız için bazı önemli kavramları derinleştirmenize yardımcı olabilir. Her neyse, girişimcilik eğiliminiz nasıl ve girişimci sosyal becerileriniz nasıl?",

        "1-2": "Tarımda bir girişimci olarak deneyiminiz olmadığından, öncelikle girişimcilik eğiliminizi ve çalışmak istediğiniz alanda başarılı olmak için bazı teknik veya sosyal beceriler edinmeniz gerekip gerekmediğini anlamak önemlidir. Bu konuda şunu söyleyebiliriz",

        "1-4": {

            score: {

                "0-1": "Tarımda başka deneyimler (profesyonellerden daha fazla) yapmış olsanız bile, bu tür deneyimler yeterince uzun (zaman açısından) veya yeni olmayabilir, bu nedenle öncelikle gerçek eğiliminizi anlamak önemlidir. Girişimcilik için ve 4.0 ÇİFTÇİ olarak başarılı olmak için gerekli becerilere sahipseniz, bu konuda şunu söyleyebiliriz",

                "2" : "Tarımda (profesyoneller dışında) bazı yeni ve önemli deneyimler yapmış olsanız bile, girişimci olarak hiç deneyiminiz yok, bu nedenle öncelikle gerçek girişimcilik eğiliminizi anlamak önemlidir, 4.0 ÇİFTÇİ olarak başarılı olmak için gereken beceri düzeyine sahipseniz, bu konuda şunu söyleyebiliriz"

            }

        },

        "2": {

            score: {

            "39": "Muhtemelen girişimcilikten kaçınmalısınız. Gerçek beklentilerinizi doğrulamak için bir değerlendirici ile görüşmenizi öneririz.",

            "59": "Serbest meslek / girişimcilik sizin için uygun bir kariyer olmayabilir. Gerçek beklentilerinizi doğrulamak için bir değerlendirici ile görüşmenizi öneririz.",

            "79" : "Görünüşe göre girişimci olmak için tatmin edici yeteneklere sahipsin.",

            "100": "Girişimci olmak için olağanüstü yetenekleriniz var gibi görünüyor.",

            }

        },

        "3-1": {

            score: {

            "44": "Yaratıcılık senin için bir rahatsızlıktır. Yaratıcılıkta herhangi bir fırsat görmüyorsunuz. Yaratıcı olmanız gereken durumlardan kaçınırsınız. Yapılandırılmış ve mantıklı bir şekilde çalışmayı tercih edersiniz. Çok değişen durumları veya karar alma sürecini sevmiyorsunuz. Tarım 4.0'da başarılı olmak istiyorsanız, yaratıcılığınızı geliştirmenizi öneririz (yani, bu yumuşak beceriyle ilgili bir kursu takip edin veya bir eğitmenden / mentordan yardım isteyin).",

            "64": "Senin için yaratıcılık bir görev. Hangi görevleri yapacağınızı bildiğiniz ve nadiren yaratıcı olmanız gereken bir işi tercih edersiniz. Ancak durum gerektirdiğinde alternatif çözümler bulabiliyorsunuz. Daha esnek olarak yaratıcılığınızı geliştirebilirsiniz. Tarım 4.0'da başarılı olmak istiyorsanız, yaratıcılığınızı geliştirmenizi öneririz (yani, bu yumuşak beceriyle ilgili bir kursu takip edin veya bir eğitmenden / mentordan yardım isteyin).",

            "84" : "Sizin için yaratıcılık gerekli. Yaratıcılık sizin için bir sorun değil, ancak çoğu zaman gereklidir. İşleri yeni yollarla yapmak bir değerdir ve bazen bir gerekliliktir. Bazen çözümün \"bilinmeyen\" de bulunması gerektiğine inanıyorsunuz. Sabit prosedürler ile alternatiflere açık olmak arasında bir denge kurabilirsiniz. Rutin işler yaparken hala titiz olmanız gerektiğini unutmayın. Tarım 4.0'da başarılı olmak isteyenler için bu iyi.",

            "100": "Sizin için yaratıcılık bir zevktir. Pek çok fikriniz var ve her zaman yeni ilhamlar, yeni fikirler ve yeni projeler bulmaya hazırsınız. Yaratıcılığınızı ve fantezinizi harekete geçiren bir ortamda olmanız gerekiyor aksi halde sıkılırsınız ve yeterince değerli hissetmezsiniz. Ama lütfen dikkat edin: sezgi gereklidir, ancak yeterli değildir! Tarım 4.0'da başarılı olmak isteyenler için bu iyi."

            }

        },

        "3-2": {

            score: {

            "2": "Çok kararlı değilsiniz (kısa vadede) ve hedeflerinize ulaşmak için (orta ila uzun vadede) tutarlılık eksikliği uyguluyorsunuz. Bu, tarımda başarılı bir girişimci olarak çalışmak isteyenler için iyi değil: Aslında girişimcilerin en önemli özelliklerinden biri kararlılıktır. Bu özellik, özgüvenle yakından ilgilidir. Kendinize ne kadar çok inanırsanız, muazzam engellerle karşılaştığınızda başarı için mücadeleye devam etme olasılığınız o kadar artar. Her yeni girişimi engelleyen sorunların üstesinden gelmek için kararlılığa ihtiyacınız var. Lütfen, hedeflerinize ulaşmada kararlı ve tutarlı olma kapasitenizi geliştirmeyi dikkate alın (örn. Bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            "5": "Her zaman kararlı değilsiniz (kısa vadede) ve bazen hedeflerinize ulaşmaya çalışırken (orta ila uzun vadede) tutarlı olamayabilirsiniz. Bu, tarımda başarılı bir girişimci olarak çalışmak isteyenler için iyi değil: Aslında girişimcilerin en önemli özelliklerinden biri kararlılıktır. Bu özellik, özgüvenle yakından ilgilidir. Kendinize ne kadar çok inanırsanız, muazzam engellerle karşılaştığınızda başarı için mücadeleye devam etme olasılığınız o kadar artar. Her yeni girişimi engelleyen sorunların üstesinden gelmek için kararlılığa ihtiyacınız var. Lütfen, hedeflerinize ulaşmada kararlı ve tutarlı olma kapasitenizi geliştirmeyi dikkate alın (örneğin, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            "6" : "Çok kararlısınız (kısa vadede) ve hedeflerinize ulaşmaya çalışırken (orta ve uzun vadede) çok tutarlısınız. Bu, tarımda bir girişimci için mükemmeldir.",

            "9": "Diğer insanların eylemlerini değersizleştirme ve eylemin kendisinden ziyade eylemde bulunan kişiye karşı olumsuz duygular gösterme eğiliminiz var. Tarımda başarılı bir girişimci olarak çalışmak isteyenler için bu iyi değil. Lütfen başkalarıyla daha fazla işbirliği yapma kapasitenizi geliştirmeyi dikkate alın (yani, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            "12": "Genel olarak, diğer insanların eylemlerini değersizleştirme ve eylemin kendisinden ziyade eylemde bulunan kişiye karşı olumsuz duygular gösterme eğilimindesiniz. Tarımda başarılı bir girişimci olarak çalışmak isteyenler için bu iyi değil.  Lütfen başkalarıyla daha fazla işbirliği yapma kapasitenizi geliştirmeyi dikkate alın (yani, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            }

        },

        "3-3": {

            score: {

            "2": "Genel olarak, eylemlerinizden sorumlu hissetmeme konusunda güçlü bir eğilim gösterirsiniz: başarılı girişimciler, bir girişimin sonucu için dahili bir kontrol odağına veya iç sorumluluk duygusuna sahiptir. Bir girişimci olmak için, eylemlerinizden sorumlu olan güçlü bir \"galip\" olma duygusuna sahip olmalısınız. Bununla birlikte, sık sık kendinizi bir \"kurban\" olarak görüyor ve başarısızlıklarınız için diğer insanları, kötü şansları veya zor koşulları suçluyorsanız, girişimcilik sizin için doğru kariyer hareketi olmayabilir. Bu konuda çalışmanızı tavsiye ederiz (yani, bu sosyal beceriler üzerine bir kursu takip edin veya bir eğitmenden / mentordan yardım isteyin).",

            "5": "Genel olarak, eylemlerinizden sorumlu hissetmek için makul bir eğilim gösterirsiniz: başarılı girişimciler, bir girişimin sonucu için dahili bir kontrol odağına veya iç sorumluluk duygusuna sahiptir. Bir girişimci olmak için, eylemlerinizden sorumlu olan güçlü bir \"galip\" olma duygusuna sahip olmalısınız. Bununla birlikte, sık sık kendinizi bir \"kurban\" olarak görüyor ve başarısızlıklarınız için diğer insanları, kötü şansı veya zor koşulları suçluyorsanız, girişimcilik sizin için doğru kariyer hareketi olmayabilir. Bu konuda çalışmanızı tavsiye ederiz (yani, bu sosyal beceriler üzerine bir kursu takip edin veya bir eğitmenden / mentordan yardım isteyin).",

            "6" : "Kendinizi sorumlu hissetmek için yeterli bir eğilim ve dolayısıyla hedeflere ulaşmak için kendinizi adama konusunda eşit derecede yeterli bir eğilim gösterirsiniz: Başarılı girişimciler, bir girişimin sonucu için dahili bir kontrol odağına veya iç sorumluluk duygusuna sahiptir. Bir girişimci olmak için, eylemlerinizden sorumlu olan güçlü bir \"galip\" olma duygusuna sahip olmalısınız. Bununla birlikte, sık sık kendinizi bir \"kurban\" olarak görüyor ve başarısızlıklarınız için diğer insanları, kötü şansı veya zor koşulları suçluyorsanız, girişimcilik sizin için doğru kariyer hareketi olmayabilir. Sizi girişkenliğinizi geliştirmeye davet ediyoruz (yani, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek)",

            "9": "Kendinizi sorumlu hissetmek için iyi bir eğilim ve dolayısıyla hedeflere ulaşmak için kendinizi adama konusunda eşit derecede iyi bir eğilim gösteriyorsunuz. Bu, tarımda başarılı bir girişimci olmak isteyenler için iyidir.",  

            "12": "Kendinizi sorumlu hissetme yönündeki mükemmel eğiliminizi ve dolayısıyla hedeflere ulaşmak için kendinizi adama konusunda eşit derecede mükemmel bir eğilim gösterirsiniz. Bu, tarımda başarılı bir girişimci olmak isteyenler için mükemmel.",  

            }

        },

        "3-4": {

            score: {

            "2": "Her şeyi kontrol altında tutma eğiliminiz olabilir (seçici yetenek eksikliği) ve kısa vadeli hedefleri uzun vadeli hedeflerle karıştırabilir, bu da son tarihlerle boğulmanıza neden olabilir. Girişimciler risk alan kişiler olduğu için, bu durum iyileştirilmelidir (yani bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmene / mentordan yardım istemek). İşlerinde başarılı olmak için kariyerlerini, zamanlarını ve paralarını riske atıyorlar. Serbest meslekte başarılı olmak için makul riskler alma konusunda kendinizi rahat hissetmelisiniz.",

            "5": "Hedeflere öncelik vermeniz zor olabilir ve çok acil olan ve olmayan konuları her zaman ayırt edemeyebilirsiniz. Bu çok stresli durumlara yol açabilir. Girişimciler risk alan kişilerdir. İşlerinde başarılı olmak için kariyerlerini, zamanlarını ve paralarını riske atıyorlar. Serbest meslekte başarılı olmak için makul riskler alma konusunda kendinizi rahat hissetmelisiniz. Bu durum iyileştirilmelidir (yani, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            "6" : "Hedeflere öncelik verme konusunda yüksek bir yeteneğiniz var ve çok acil olan ile acil olmayan konuları, bir girişimci için bunun nasıl gerekli olduğunu ayırt edebilirsiniz.",

            "9": "Günlük görevlerinizi tamamlamada ve hedeflerinize ulaşmada zorluk çekiyorsunuz. Bu arada, girişimcilerin başarıya ihtiyacı var. Oldukça yüksek olan hedefleri başarıya ulaştırmak için çabalarlar. Kendiniz için yüksek hedefler belirlemeye istekli olmalısınız ve bu hedeflere ulaşmak için çabalamaktan zevk almalısınız. Bunu göz önünde bulundurarak, becerilerinizi geliştirmelisiniz (yani, bu yumuşak beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek).",

            "12": "Günlük görevlerinizi tamamlamada ve hedeflerinize ulaşmada zorluk çekiyorsunuz. Bununla birlikte, bu durum iyileştirilebilir (yani, bu sosyal beceriler üzerine bir kursu takip etmek veya bir eğitmenden / mentordan yardım istemek), çünkü girişimciler risk alan kişilerdir. İşlerinde başarılı olmak için kariyerlerini, zamanlarını ve paralarını riske atıyorlar. Serbest meslekte başarılı olmak için makul riskler alma konusunda kendinizi rahat hissetmelisiniz.",

            }

        },

        "3-5": {

            score: {

            "2": "Başkalarının yardımı olmaksızın \"kendin yap\" ve kendi liderliğiniz / inisiyatifiniz / güdünüzle hareket etme konusunda güçlü bir yeteneğiniz var. Ancak bazen başarıya ulaşmak istiyorsanız tavsiye, bilgi ve yönlendirmeler için diğer profesyonellere danışmanız gerekir. Bu nedenle, diğer muhatapları içeren profesyonel hedeflerinize ulaşma becerinizi geliştirmenizi öneririz.",

            "5": "Başkalarından yardım istemeden kendi inisiyatifiniz / sürücünüz / yeteneğinizle çalışma konusunda ortalama bir yeteneğiniz var. Ancak bazen bu yeterli olmayabilir. Bu nedenle, diğer muhatapları içeren profesyonel hedeflerinize ulaşma becerinizi geliştirmenizi öneririz.",

            "6" : "Kendi inisiyatifiniz / yeteneğiniz / dürtüleriniz üzerinde çok fazla çalışabilirsiniz, ancak aynı zamanda diğer insanlardan ne zaman yardım alacağınızı da bilirsiniz ve bu, diğer muhatapları içeren profesyonel hedeflere ulaşmak isteyen sizin gibi biri için mükemmeldir.",

            "9": "Görev atama konusunda ortalama bir yeteneğiniz olsa da, bazen kararınızı çok fazla desteklemek için başkalarının yardımına ve pek çok bilgiye güveniyorsunuz. Bu nedenle, diğer muhatapları içeren profesyonel hedeflerinize, manipülasyonlarına varmadan ulaşma yeteneğinizi geliştirmenizi öneririz.",

            "12": "Görevleri çok atayabilirken, çok fazla yardım isteme ve kararlarınızı desteklemek için çok fazla bilgi arama eğilimindesiniz ve bu olabilir. Bu nedenle, diğer muhatapları içeren profesyonel hedeflerinize, manipülasyonlarına varmadan ulaşma yeteneğinizi geliştirmenizi öneririz.",

            }

        },

        "4-1": {

            score: {

            "5": "FARMER 4.0 araçlarını kullanabilmek istiyorsanız, bir kursun ardından (en azından temel düzeyde) genel bilişim bilginizi genişletmeniz / genişletmeniz / geliştirmeniz gerekir.",

            "8": "FARMER 4.0 araçlarını düzgün bir şekilde kullanabilmek istiyorsanız, bir kursu takiben bilginizi geliştirebilirsiniz (orta seviye).",

            "10" : "Tebrikler: Genel BİT bilginiz ileri düzeydedir ve FARMER 4.0 araçlarını ve modellerini kullanırken herhangi bir sorun yaşamazsınız.",

            }

        },

        

        "4-2-1": {

            "yes":"CAD'de zaten çalışabiliyor olsanız bile, sizi FARMER 4.0 platformunda CAD / CAM / CAE / RE modülüne bir göz atmaya davet ediyoruz.",

            "no": "CAD modülünü FARMER 4.0 platformunda takip etmeniz gerekmektedir",

        },

        "4-2-2": {

            "yes": "CAE'de zaten çalışabilecek durumda olsanız bile, sizi FARMER 4.0 platformunda CAD / CAM / CAE / RE modülüne bir göz atmaya davet ediyoruz.",

            "no": "CAE modülünü FARMER 4.0 platformunda takip etmeniz gerekmektedir",

        },

        "4-2-3": {

            "yes": "Halihazırda CAM'de çalışabiliyor olsanız bile, sizi FARMER 4.0 platformunda CAD / CAM / CAE / RE modülüne bir göz atmaya davet ediyoruz.",

            "no": "CAM modülünü FARMER 4.0 platformunda takip etmeniz gerekmektedir",

        },

        "4-2-4": {

            "yes": "Zaten RE'de çalışabiliyor olsanız bile, sizi FARMER 4.0 platformunda CAD / CAM / CAE / RE modülüne bir göz atmaya davet ediyoruz.",

            "no": "FARMER 4.0 platformunda RE modülünü takip etmeniz gerekmektedir",

        },

        "4-2-5": {

            "yes": "Katmanlı imalatta zaten çalışabiliyor olsanız bile, sizi Katmanlı Üretim - FARMER 4.0 platformundaki 3D Baskı modülüne bir göz atmaya davet ediyoruz.",

            "no": "FARMER 4.0 platformunda Eklemeli Üretim - 3D Baskı modülünü takip etmeniz gerekmektedir.",

        },

        "4-2-6": {

            "yes": "Kendinizi ve çiftliğinizi / faaliyetlerinizi tanıtmak için sosyal medyayı (ör. Facebook, Instagram, Pinterest…) veya bir web sitesini zaten kullanabiliyor olsanız veya ürünlerinizi satsanız bile, sizi FARMER 4.0 platformunda “Global Farm 4.0 için Sosyal Ağ” ve “Çevrimiçi iletişim araçları ve teknikleri” modüllerine davet ediyoruz.”",

            "no": "FARMER 4.0 platformunda \"Global Farm 4.0 için Sosyal Ağ\" ve \"Çevrimiçi iletişim araçları ve teknikleri\" modüllerini takip etmeniz gerekmektedir.",

        },

        "5-1": {

            "yes": "Zaten bir fablab yaklaşımı ile çalışabiliyor olsanız ve tarımda dijitalleşmeyi çok iyi biliyor olsanız bile, sizi FARMER 4.0 platformunda \"FabLab yaklaşımına dayalı Tarımsal Girişimcilik\" modülüne bir göz atmaya davet ediyoruz.",

            "no": "FARMER 4.0 platformunda \"FabLab yaklaşımına dayalı Tarımsal Girişimcilik\" modülünü takip etmeniz gerekmektedir",

        },

        "5-2": {

            "yes": "Halihazırda uluslararası bağlamda çalışabiliyor olsanız bile, sizi FARMER 4.0 platformunda \"Global Farm 4.0'ın Uluslararasılaşması ve sürdürülebilirliği\" modülüne bir göz atmaya davet ediyoruz",

            "no": "FARMER 4.0 platformunda “Global Farm 4.0'ın Uluslararasılaşması ve sürdürülebilirliği” modülünü takip etmeniz gerekmektedir.",

        },

        "5-3": {

            "yes": "Tarımın sürdürülebilirliği için çalışsanız bile, sizi FARMER 4.0 platformunda \"Global Farm 4.0'ın Uluslararasılaşması ve sürdürülebilirliği\" modülüne bir göz atmaya davet ediyoruz.",

            "no": "FARMER 4.0 platformunda “Global Farm 4.0'ın Uluslararasılaşması ve sürdürülebilirliği” modülünü takip etmeniz gerekmektedir."

        }

    }

}

